import React, { useState } from 'react'
import { PageLayout } from '../components/common/PageLayout'
import { Section, FeatureCard } from '../components/common/DesignComponents'
import { useNavigation } from '../contexts/NavigationContext'

export function BlogPage(): React.ReactElement {
  const { openModal } = useNavigation()
  const [email, setEmail] = useState('')
  const [subscribed, setSubscribed] = useState(false)

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault()
    if (email) {
      console.log('Subscribed with email:', email)
      setSubscribed(true)
      setTimeout(() => {
        setEmail('')
        setSubscribed(false)
      }, 2000)
    }
  }

  const handleReadMore = (postId: number) => {
    openModal('contact' as any)
  }
  const blogPosts = [
    {
      id: 1,
      title: 'Getting Started with BabyKingdom: A Parent\'s Guide',
      date: 'March 15, 2026',
      excerpt: 'Learn how to set up your first child profile and explore all the amazing features available.',
      emoji: '👶',
    },
    {
      id: 2,
      title: 'The Science Behind Child Development in Games',
      date: 'March 12, 2026',
      excerpt: 'Discover how BabyKingdom uses child psychology principles to create educational experiences.',
      emoji: '🧠',
    },
    {
      id: 3,
      title: 'Screen Time Tips: How to Balance Gaming and Learning',
      date: 'March 10, 2026',
      excerpt: 'Expert advice on managing healthy screen time while maximizing educational benefits.',
      emoji: '⏱️',
    },
    {
      id: 4,
      title: 'New Feature Release: Family Multiplayer Events',
      date: 'March 8, 2026',
      excerpt: 'Play together with your family! Introducing cooperative multiplayer games and challenges.',
      emoji: '👨‍👩‍👧‍👦',
    },
    {
      id: 5,
      title: 'Success Stories: How BabyKingdom Changed Families',
      date: 'March 5, 2026',
      excerpt: 'Read inspiring stories from real parents and children who love using BabyKingdom.',
      emoji: '✨',
    },
    {
      id: 6,
      title: 'Monthly Newsletter: Updates and Tips',
      date: 'March 1, 2026',
      excerpt: 'Stay updated with the latest features, tips, and community highlights from BabyKingdom.',
      emoji: '📰',
    },
  ]

  return (
    <PageLayout title="Blog" subtitle="Tips, updates, and stories from the BabyKingdom community">
      <Section title="Latest Articles">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <div key={post.id} className="p-6 bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl border-4 border-purple-200 shadow-lg hover:shadow-xl transition cursor-pointer">
              <div className="text-5xl mb-3">{post.emoji}</div>
              <p className="text-sm text-gray-500 font-bold mb-2">{post.date}</p>
              <h3 className="text-xl font-black text-purple-700 mb-3">{post.title}</h3>
              <p className="text-gray-700 font-semibold mb-4">{post.excerpt}</p>
              <button onClick={() => handleReadMore(post.id)} className="text-pink-600 font-black hover:text-purple-700 cursor-pointer">Read More →</button>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Subscribe to Our Newsletter">
        <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-12 rounded-3xl border-4 border-purple-200 text-center">
          <h3 className="text-2xl font-black text-purple-700 mb-3">Stay Updated! 📬</h3>
          <p className="text-gray-700 font-bold mb-6 max-w-md mx-auto">Get weekly tips, new game releases, and exclusive offers delivered to your inbox.</p>
          {subscribed ? (
            <div className="p-4 bg-green-50 rounded-full border-4 border-green-300 text-center">
              <p className="text-green-700 font-black">✅ Thanks for subscribing!</p>
            </div>
          ) : (
            <form onSubmit={handleSubscribe} className="flex gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 px-6 py-3 rounded-full border-4 border-purple-300 font-bold focus:outline-none focus:border-pink-400"
              />
              <button type="submit" className="px-8 py-3 bg-gradient-to-r from-pink-400 to-purple-400 text-white font-black rounded-full shadow-lg hover:shadow-xl transition">
                Subscribe
              </button>
            </form>
          )}
        </div>
      </Section>
    </PageLayout>
  )
}
